<div class="survey__screen survey-done">
  <% if ( confetti.length ) { %>
  <div class="survey-done__confetti" aria-hidden="true">
    <% confetti.forEach( function( i ) { %><span class="survey-done__bit survey-done__bit--<%= i % 4 %>" style="--i: <%= i %>"></span><% } ); %>
  </div>
  <% } %>

  <div class="survey-done__body">
    <div class="survey-done__badge" aria-hidden="true">
      <i class="icon icon--trophy"></i>
    </div>
    <p class="survey-done__eyebrow"><%= _lcs( 'Gipfelstürmer' ) %> 🏔️</p>
    <h1 class="survey-done__title">
      <%= already ? _lcs( 'Danke, dein Feedback ist schon angekommen' ) : _lcs( 'Danke für dein Feedback!' ) %>
    </h1>
    <% if ( thankYou ) { %>
    <p class="survey-done__text">„<%= thankYou %>“</p>
    <% if ( house ) { %><p class="survey-done__from">— <%= house %></p><% } %>
    <% } else { %>
    <p class="survey-done__text">
      <%= house ? _lcs( 'Deine Antworten helfen {house}, noch besser zu werden.', { house: house } ) : _lcs( 'Deine Antworten helfen deinen Gastgebern, noch besser zu werden.' ) %>
    </p>
    <% } %>
    <button type="button" class="survey__cta" data-action="home"><%= homeLabel %></button>
  </div>
</div>
